/*
 * Copyright (C) 2024 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {ExdsLayout, ExdsLayoutItem, ExdsText} from '@exds/core';
import {ExdsButtonTray} from '@exds/containers';
import Footer from '../Footer/Footer';
import {AppContext} from '../../AppContext';
import './NotFoundPage.css';

function NotFoundPage(){
  const {helpLink} = useContext(AppContext);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleTertiaryClick = () => {
    window.open(helpLink || '/', '_blank', 'noopener,noreferrer');
  };

  return(
    <div className="not-found-page-shell">
      <ExdsLayout display="flex" flexDirection="column" alignItems="center" className="not-found-page-layout">
        <ExdsLayoutItem flexBasis="568px" flexShrink={1} className="not-found-page-card-layout-item">
          <ExdsLayout display="flex" flexDirection="column" gap="16px" className="not-found-page-content-layout">
            <div className="not-found-page-card-content">
              <ExdsText primitive="p" alignment="left" textStyle="headlineSmall" style={{ margin: 0 }} data-testid="not-found-header">
                Oh no! We can&#39;t find this page...
              </ExdsText>

              <ExdsText
                primitive="p"
                color="regular"
                textStyle="bodyMedium"
                className="landing-paragraph-top-margin"
                data-testid="not-found-description"
              >
                Make sure your address is correct or start over.
              </ExdsText>

              <ExdsButtonTray
                style={{width: '100%', marginTop: '24px'}}
                primaryButton='Try Again'
                tertiaryButton='Contact Ask JPMC'
                onPrimaryButtonClick={handleBackClick}
                onTertiaryButtonClick={handleTertiaryClick}
              />
            </div>
          </ExdsLayout>
        </ExdsLayoutItem>
      </ExdsLayout>

      <Footer />
    </div>
  );
}

export default NotFoundPage;
